import React from 'react';
import './Hiring_Partners.css';

const Hiring_Partners = () => {
  return (
    <section className="hiring-section">
      <h2 className="section-title">Get access to Hiring Corporates</h2>
      <p className="section-subtitle">Tie-ups with 200+ Hiring Partners</p>
      <div className="logo-image-wrapper">
        <img src={"/assets/images/edtech_assets/images/thank_you/hiring.jpg"} alt="Hiring Partner Logos" className="logo-image" />
      </div>
    </section>
  );
};

export default Hiring_Partners;
